import benefits from '../tourism/benefits';
import services from '../tourism/services';
import reviews from '../tourism/reviews';
import socials from '../tourism/socials';
import forms from '../tourism/forms';

export default {
    init() {
        benefits();
        services();
        reviews();
        socials();
        forms();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateTourism.js